/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".actions-list[_ngcontent-%COMP%]{position:absolute;right:0;bottom:100%;margin-bottom:-5px}.actions-list__item[_ngcontent-%COMP%]{cursor:pointer;background:#3f8979;border:none;color:#fff;width:24px;height:24px;font-size:.8em;border-radius:4px}"];
export { styles as styles };
